import { ReactNode } from "react"

const Paragraph = ({ children }: { children: ReactNode }) => (
  <p className="mt-2 text-base text-gray-600 sm:mt-4 sm:text-lg">{children}</p>
)

const Heading = ({ children }: { children: ReactNode }) => (
  <h3 className="text-2xl font-bold text-gray-900 sm:text-3xl">{children}</h3>
)

const FeatureContainer = ({
  children,
  illustration,
}: {
  reverse?: boolean
  children: ReactNode
  illustration: ReactNode
}) => (
  <div className="flex flex-col gap-y-5 sm:gap-y-12 lg:grid lg:grid-cols-2 lg:items-center lg:gap-x-24">
    <div className="relative order-first flex flex-col items-center justify-center lg:order-last">
      <div className="flex w-full justify-center rounded-3xl bg-gray-50 px-4 py-6 sm:p-10">
        {illustration}
      </div>
    </div>
    <div className="mx-auto sm:max-w-md lg:max-w-none">{children}</div>
  </div>
)

FeatureContainer.Paragraph = Paragraph
FeatureContainer.Heading = Heading

export default FeatureContainer
